import { MenuItem, Stack, TextField } from "@mui/material";
import {
  DriverHosStatus,
  GetBusinessEntityListQuery,
  TrailerType,
} from "../../../graphql/generated";
import EnumSelect from "../../common/EnumSelect";
import { useTranslation } from "react-i18next";
import { testIds } from "./AssetFilters.testIds";

type AssetFiltersProps = {
  filters: AssetFiltersValue;
  domiciles: GetBusinessEntityListQuery["businessEntities"]["data"];
  onChange: (filters: AssetFiltersValue) => void;
};

export type AssetFiltersValue = Partial<{
  trailerTypes: TrailerType[] | null;
  hosRange: number[] | null;
  hosStatus: DriverHosStatus | null;
  domicileIds: string[] | null;
}>;
const AssetFilters = ({ filters, domiciles, onChange }: AssetFiltersProps) => {
  const { t } = useTranslation(["planning", "trailers"]);

  return (
    <Stack spacing={2} paddingTop={2}>
      <EnumSelect data-testid="asset-filters-trailer-type"
        multiple
        enumObject={TrailerType}
        label={t("filters.trailerType")}
        value={filters.trailerTypes}
        onChange={(_, trailerTypes) => onChange({ ...filters, trailerTypes })}
        optionLabel={(trailerType) =>
          t(`trailers:trailerTypeEnum.${trailerType}`)
        }
      />

      <TextField
        select
        label={t("filters.domicile")}
        value={filters?.domicileIds || []}
        onChange={(event) => {
          onChange({
            ...filters,
            // @ts-ignore
            domicileIds: event.target.value as string[],
          });
        }}
        SelectProps={{
          multiple: true,
        }}
        fullWidth
      inputProps={{ "data-testid": testIds.assetFiltersDomicile } as React.InputHTMLAttributes<HTMLInputElement>}
      >
        {domiciles.map((domicile) => (
          <MenuItem data-testid={`${testIds.assetFiltersDomicileOption}-${domicile._id}`} key={domicile._id} value={domicile._id}>
            {domicile.name}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export default AssetFilters;
